module.exports = __webpack_public_path__ + "static/media/left_forearm_flexed.7ba1e5e1.png";